import dayjs from 'dayjs';
import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';
import _ from 'lodash';
import getLotById from './getLotById.api';
import getLotModels from './getLotModels.api';

export default async function getModelLots(modelId, callback) {
	var getLots = firebase
		.functions()
		.httpsCallable('CheckLotAvailabilityOnModels');
	var jsonInfo = {
		projectCode: PROJECT_CODE.projectCode,
	};

	// getLots(jsonInfo, (callback) => {
	// 	console.log('calllback', callback);
	// });

	getLots(jsonInfo).then(async (returned) => {
		console.log('getModelLots returned', returned.data);

		var modelsObj;

		if (modelId !== 'all' && modelId !== ' ') {
			console.log('test odadada', modelId, modelsObj);
			modelsObj = returned.data[modelId];

			let lotList = [];
			await firebase
				.database()
				.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
				.once('value', (snapshot) => {
					let lotAssignment;

					snapshot.forEach((lot) => {
						let lotName = lot.val().lotId;
						let availabilityValue = lot.val()?.available;
						let coBrokerValue = lot.val()?.coBroker;
						let assignedSalesAgentValue =
							lot.val()?.assignedSalesAgent;
						let assignedCoBrokerValue = lot.val()?.assignedCoBroker;
						let closingDateValue = lot.val()?.closingDate;
						let lotPrice = lot.val()?.lotPrice;
						let premiumDescription = lot.val()?.premiumDescription;
						let lotSize = lot.val()?.lotSize;
						let lotSizeType = lot.val()?.lotSizeType;
						let buildings = lot.val()?.buildings;
						let pricing = lot.val()?.pricing;

						lotAssignment = {
							lot: lotName,
							availability: availabilityValue,
							assignedSalesAgent: assignedSalesAgentValue,
							assignedCoBroker: assignedCoBrokerValue,
							closingDate: closingDateValue,
							lotPrice: lotPrice,
							premiumDescription: premiumDescription,
							lotSize: lotSize,
							lotSizeType: lotSizeType,
							buildings: buildings,
							pricing: pricing,
						};

						lotList.push(lotAssignment);
					});
				});

			var modelsArr = [];

			var modelsKeys = modelsObj;
			var modelName = modelId;
			var modelsKeysKeys = modelsKeys ? Object.keys(modelsKeys) : [];

			var lotsArray = [];

			modelsKeysKeys.forEach((elevationKey) => {
				var lots = modelsKeys[elevationKey];

				lotsArray.push(lots);
			});
			console.log('wjefjwf', lotsArray);

			var mergedArray = [].concat.apply([], lotsArray);

			var uniqueArray = _.uniq(mergedArray);

			var arrayToUse = [];
			uniqueArray.forEach((lot) => {
				lotList.forEach((lotInList) => {
					if (lotInList.lot === Number(lot)) {
						var lotModelsArr = [];
						getLotModels(lot, (returned) => {
							var lotModels = returned;

							var lotModelsKeys = Object.keys(returned);

							lotModelsKeys.forEach((key) => {
								console.log('wefjwefoef', modelName);
								if (lotModels[key][modelName]) {
									lotModelsArr.push(
										lotModels[key][modelName]
									);
								}
							});
							console.log('wfwefwefw', lotModelsArr);
						});

						arrayToUse.push(lotInList);
					}
				});
			});

			callback([
				{
					[modelId]: modelsObj,
					lots: arrayToUse,
				},
			]);
		} else {
			modelsObj = returned.data;

			console.log('getModelLots modelsObj', modelsObj);

			var modelsObjKeys = Object.keys(modelsObj);

			console.log('getModelLots modelsObjKeys', modelsObjKeys);

			let lotList = [];
			await firebase
				.database()
				.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
				.once('value', (snapshot) => {
					let lotAssignment;

					snapshot.forEach((lot) => {
						let lotName = lot.val().lotId;
						let availabilityValue = lot.val()?.available;
						let coBrokerValue = lot.val()?.coBroker;
						let assignedSalesAgentValue =
							lot.val()?.assignedSalesAgent;
						let assignedCoBrokerValue = lot.val()?.assignedCoBroker;
						let closingDateValue = lot.val()?.closingDate;
						let lotPrice = lot.val()?.lotPrice;
						let premiumDescription = lot.val()?.premiumDescription;
						let lotSize = lot.val()?.lotSize;
						let lotSizeType = lot.val()?.lotSizeType;
						let buildings = lot.val()?.buildings;
						let pricing = lot.val()?.pricing;

						lotAssignment = {
							lot: lotName,
							availability: availabilityValue,
							assignedSalesAgent: assignedSalesAgentValue,
							assignedCoBroker: assignedCoBrokerValue,
							closingDate: closingDateValue,
							lotPrice: lotPrice,
							premiumDescription: premiumDescription,
							lotSize: lotSize,
							lotSizeType: lotSizeType,
							buildings: buildings,
							pricing: pricing,
						};

						lotList.push(lotAssignment);
					});
				});

			var modelsArr = [];

			modelsObjKeys.forEach((key) => {
				var modelsKeys = modelsObj[key];
				var modelName = key;

				var modelsKeysKeys = Object.keys(modelsKeys);

				var lotsArray = [];

				modelsKeysKeys.forEach((elevationKey) => {
					var lots = modelsKeys[elevationKey];

					lotsArray.push(lots);
				});

				var mergedArray = [].concat.apply([], lotsArray);

				var uniqueArray = _.uniq(mergedArray);

				var arrayToUse = [];
				uniqueArray.forEach((lot) => {
					lotList.forEach((lotInList) => {
						if (lotInList.lot === Number(lot)) {
							var lotModelsArr = [];
							getLotModels(lot, (returned) => {
								var lotModels = returned;

								var lotModelsKeys = Object.keys(returned);

								lotModelsKeys.forEach((key) => {
									console.log('wefjwefoef', modelName);
									if (lotModels[key][modelName]) {
										lotModelsArr.push(
											lotModels[key][modelName]
										);
									}
								});
							});

							arrayToUse.push(lotInList);
						}
					});
				});

				console.log('mergedArray', arrayToUse);
				modelsArr.push({
					[key]: modelsObj[key],
					lots: arrayToUse,
				});
			});

			console.log('modelsArrrra', modelsArr);

			callback(modelsArr);
		}
	});
}
